import { css } from 'styled-components';

const variables = css`
  :root {
    --bg-base: #0f0f0f;
    --bg-surface: #0f0f0f;
    --bg-surface-elevated: #0f0f0f;
    --border-color: #0f0f0f;
    --text-primary: #9a9498;
    --text-muted: #9a9498;
    --text-soft: #9a9498;
    --accent: #2a6af2;
    --accent-hover: #2a6af2;
    --accent-dark: #2a6af2;
    --accent-tint: rgba(42, 106, 242, 0.14);
    --accent-soft-tint: rgba(42, 106, 242, 0.2);
    --accent-glow: rgba(42, 106, 242, 0.28);
    --navy-shadow: rgba(42, 106, 242, 0.16);

    /* Legacy aliases used throughout the older component styles */
    --dark-navy: var(--bg-base);
    --navy: var(--bg-base);
    --light-navy: var(--bg-surface);
    --lightest-navy: var(--border-color);
    --dark-slate: #9a9498;
    --slate: var(--text-muted);
    --light-slate: var(--text-soft);
    --lightest-slate: var(--text-primary);
    --white: var(--text-primary);
    --green: var(--accent);
    --green-hover: var(--accent-hover);
    --green-dark: var(--accent-dark);
    --green-tint: var(--accent-tint);
    --pink: #f57dff;
    --blue: var(--accent-hover);

    --font-sans: 'Open Sans', 'Helvetica Neue', Arial, sans-serif;
    --font-name: 'JetBrains Mono', 'SF Mono', 'Fira Code', 'Roboto Mono', monospace;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
